<template>
  <el-container class="m-template template-index">
    <el-header class="template-header m-header">
      <div class="template-uploader-box" v-if="uploaderVisible">
        <!--banner新数据结构和图文一致，只是编辑时做了转换，所以上传、属性配置都使用图文组件组件 -->
        <tpl-group-uploader
          @success="onUploadSuccess"
          :projectId="projectId"
          :multi="multiUploader"
        />
        <tpl-group-uploader
          btnName="上传banner模板"
          :type="singleType"
          :multi="multiUploader"
          :projectId="projectId"
          @success="onUploadSuccess"
        />
        <tpl-group-uploader
          @success="onUploadSuccess"
          :type="pptType"
          :multi="multiUploader"
          :projectId="projectId"
          btnName="上传ppt模板"
        />
        <div class="c-f-right">
          <el-button round type="primary" @click="$emit('open')"
            >分类管理</el-button
          >&emsp;
          <template-demo></template-demo>
        </div>
      </div>
      <div class="tag">
        <div class="label">
          模板分类
          <span>|</span>
        </div>
        <div class="content">
          <span
            class="item"
            @click="chooseAll"
            :class="{ active: state.pickedTagIndex === -1 }"
            >全部</span
          >
          <span
            class="item"
            @click="choseTag(item.name, index, item.id)"
            v-for="(item, index) in tagsList"
            :key="index"
            :class="{ active: state.pickedTagIndex === index }"
            >{{ typeNameMap[item.name] || item.name }}
            <i
              @click.stop="onDelTag(item, index)"
              class="el-icon-close del-tag"
              v-if="!isAdminPucTpl && item.id && $store.getters['app/isAdmin']"
            ></i>
          </span>
        </div>
      </div>
      <div class="condition-item" v-if="$store.getters['app/isAdmin']">
        <div class="label">
          模板状态
          <span>|</span>
        </div>
        <div class="content">
          <span
            class="item"
            @click="chooseTplStatus(null)"
            :class="{ active: param.hidden === null }"
            >全部</span
          >
          <span
            class="item"
            :class="{ active: param.hidden === false }"
            @click="chooseTplStatus(false)"
            >公开</span
          >
          <span
            class="item"
            :class="{ active: param.hidden }"
            @click="chooseTplStatus(true)"
            >隐藏</span
          >
        </div>
      </div>
      <div class="condition-item">
        <div class="label">
          模板版权
          <span>|</span>
        </div>
        <div class="content">
          <span
            class="item"
            @click="chooseCopyRight(null)"
            :class="{ active: param.canCommercial === null }"
            >全部</span
          >
          <span
            class="item"
            :class="{ active: param.canCommercial }"
            @click="chooseCopyRight(true)"
            >可商用</span
          >
          <span
            class="item"
            :class="{ active: param.canCommercial === false }"
            @click="chooseCopyRight(false)"
            >不可商用</span
          >
        </div>
      </div>
      <div class="condition-item" v-if="isAdminPage">
        <div class="label">
          模板类型
          <span>|</span>
        </div>
        <div class="content">
          <span
            class="item"
            @click="chooseFree(null)"
            :class="{ active: param.free === null }"
            >全部</span
          >
          <span
            class="item"
            :class="{ active: param.free === false }"
            @click="chooseFree(false)"
            >固定模板</span
          >
          <span
            class="item"
            :class="{ active: param.free }"
            @click="chooseFree(true)"
            >自由模板</span
          >
        </div>
      </div>
      <transition name="c-fade">
        <div class="size" v-if="isExpanded">
          <div class="label">
            模板尺寸
            <span class="slice">|</span>
          </div>
          <div class="content">
            <span
              class="item"
              @click="choseSize(null)"
              :class="{ active: state.pickedSizeIndex === -1 }"
              >全部</span
            >
            <span
              class="item"
              @click="choseSize(item, index)"
              v-for="(item, index) in sizeList"
              :key="index"
              :class="{ active: state.pickedSizeIndex === index }"
              >{{ item }}</span
            >
          </div>
        </div>
      </transition>
      <div class="expand-tools">
        <span @click="onExpandClick" class="tool-bar">
          <i
            :class="[isExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down']"
          ></i>
          <span class="switch-top">{{ isExpanded ? '收起' : '展开' }}</span>
        </span>
      </div>
    </el-header>
    <el-main
      :style="getWidth()"
      class="items-container"
      v-loading="loading"
      element-loading-background="rgba(256,256,256, 0.65)"
      element-loading-text="拼命加载中, 请稍候"
      element-loading-spinner="el-icon-loading"
    >
      <draggable
        v-model="items"
        @end="onDragEnd"
        class="tpl-list-box"
        :style="getListStyle()"
        :handle="isProjectUser ? '.no-drag' : '.m-item'"
        ghostClass="drop-receiver-class"
        dragClass="drag-move-class"
      >
        <div class="m-item" v-for="(item, index) in items" :key="index">
          <div
            class="item-box c-pointer"
            :style="{ cursor: item.templates.length > 1 ? 'auto' : 'pointer' }"
          >
            <template v-if="item.templates[0].label">
              <span
                class="template-icon tpl-group-icon"
                v-text="item.templates[0].label"
              ></span>
            </template>
            <template v-else>
              <span class="template-icon tpl-group-icon" v-if="isPPT(item.type)"
                ><i class="icon"></i>PPT</span
              >
              <span
                class="template-icon tpl-group-icon"
                v-if="isMulti(item.type)"
                ><i class="icon"></i>图文</span
              >
            </template>
            <img
              :src="item.templates[0].defaultUrl + '?imageView&thumbnail=200x0'"
            />
            <div
              v-if="item.templates.length <= 1"
              class="mask"
              @click.stop="goToEditor(item)"
            >
              <div class="opration">
                <div
                  class="template-icon-btn tpl-edit-icon"
                  @click.stop="onClickUse(item)"
                >
                  <i class="icon myico-edit"></i>
                  <div>编辑</div>
                </div>
                <div
                  class="template-icon-btn tpl-use-icon"
                  @click.stop="previewTemplate(item)"
                >
                  <i class="icon"></i>
                  <div>预览</div>
                </div>
              </div>
            </div>
            <div v-else class="mask c-pointer" @click.stop="goToEditor(item)">
              <div class="opration">
                <div
                  class="template-icon-btn tpl-edit-icon"
                  @click.stop="onClickUse(item)"
                  v-if="!isTeamTemplate(item.type)"
                >
                  <i class="icon myico-edit"></i>
                  <div>编辑</div>
                </div>
                <div
                  v-else
                  class="template-icon-btn tpl-edit-icon"
                  @click.stop="manageTemplate(item)"
                >
                  <i class="icon myico-edit"></i>
                  <div>编辑</div>
                </div>
              </div>
            </div>
            <p
              v-if="item.hidden"
              class="tpl-hidden c-tip"
              title="普通用户无法看到当前模板"
            >
              模板已隐藏
            </p>
            <p
              v-else-if="item.templates[0].canCommercial === false"
              class="tpl-commercial-mark"
            >
              <i class="mark-icon myico myico-no"></i
              ><span class="mark-text">不可商用</span>
            </p>
          </div>
          <div class="item-box-footer">
            <div class="item-name c-ellipsis">
              <span>{{
                item.templates.length > 1 ? item.name : item.templates[0].name
              }}</span>
            </div>
            <el-popover
              v-model="item.opMenuVisible"
              v-if="isPreTemplate(item) && item.templates.length > 1"
              popper-class="no-arrow"
              placement="right-start"
              width="90"
              trigger="hover"
              visible-arrow="false"
            >
              <ul>
                <li
                  v-if="item.templates.length > 1"
                  @click="manageTemplate(item)"
                >
                  管理
                </li>
              </ul>
              <div class="item-menu" slot="reference">
                <i class="el-icon-more"></i>
              </div>
            </el-popover>
            <el-popover
              v-model="item.opMenuVisible"
              v-else-if="
                !isPreTemplate(item) &&
                  ($store.getters['app/isAdmin'] || item.templates.length > 1)
              "
              popper-class="no-arrow"
              placement="right-start"
              trigger="hover"
              visible-arrow="false"
            >
              <ul>
                <li
                  v-if="item.templates.length === 1"
                  @click="onClickUpdateTemplate(item.templates[0])"
                >
                  修改模板配置
                </li>
                <li
                  v-if="freeTplBtnVisible(item)"
                  @click="onClickSwitchTemplate(item.templates[0])"
                >
                  生成自由模板
                </li>
                <li
                  v-if="
                    item.intersectionTagNames &&
                      item.intersectionTagNames.length > 0
                  "
                  @click="editTag(item)"
                >
                  修改分类
                </li>
                <li v-else @click="editTag(item)">添加分类</li>
                <li
                  v-if="item.templates.length > 1"
                  @click="manageTemplate(item)"
                >
                  管理
                </li>
                <template v-if="$store.getters['app/isAdmin']">
                  <li v-if="item.hidden" @click="onHideGroup(item)">
                    取消隐藏
                  </li>
                  <li v-else @click="onHideGroup(item)">隐藏</li>
                </template>
                <el-popover
                  placement="bottom-end"
                  v-if="$store.getters['app/isAdmin']"
                  popper-class="c-delete-propper delete-propper-work"
                  v-model="item.visible1"
                >
                  <p>
                    <i class="el-icon-warning"></i
                    >{{
                      item.templates.length > 1
                        ? '你确认要删除该组中所有模板吗？'
                        : '你确认要删除该模板吗？'
                    }}
                  </p>
                  <div style="text-align: right; margin: 0">
                    <el-button @click="item.visible1 = false">取消</el-button>
                    <el-button
                      type="primary"
                      @click="
                        item.visible1 = false
                        deleteTemplates(item)
                      "
                      >确定</el-button
                    >
                  </div>
                  <li slot="reference">删除</li>
                </el-popover>
              </ul>
              <div class="item-menu" slot="reference">
                <i class="el-icon-more"></i>
              </div>
            </el-popover>
            <div v-if="item.templates.length <= 1" class="item-size">
              {{ item.templates[0].widthHeight }}
            </div>
            <div v-if="item.templates.length > 1" class="folder"></div>
            <div v-if="item.templates.length > 1" class="folder folder2"></div>
          </div>
        </div>
      </draggable>
      <div v-if="!items.length && !loading" class="noResult">
        <img src="img/noResult.png" />
        <div>
          <div>您的团队还没有设计模板</div>
          <div>
            请联系您的设计师
            {{ projectAdmins.length > 0 ? projectAdmins[0].email : '' }}
            添加模板
          </div>
        </div>
      </div>
      <self-caroursel
        v-if="templatePreview"
        v-model="templatePreview"
        :index="current"
        :data="previewList"
        key="preview-1"
        type="template"
        @switch="onSwitchPng"
      >
        <template slot-scope="props">
          <div class="m-preview-bottom">
            <div class="opration">
              <el-button type="primary" round @click="toUseTemplate(props.data)"
                >使用模板</el-button
              >
            </div>
            <div class="info">
              <span class="title">{{ props.data.name }}</span>
              <span class="size">{{ props.data.widthHeight }}</span>
            </div>
          </div>
        </template>
      </self-caroursel>
      <p
        class="addData"
        v-show="addTemplateLoading"
        v-loading="addTemplateLoading"
        element-loading-background="rgba(0, 0, 0, 0)"
      ></p>
      <p
        class="nomoreData c-tip-msg"
        :style="{
          visibility: nomoreData && items.length !== 0 ? 'initial' : 'hidden'
        }"
      >
        没有更多数据了
      </p>
    </el-main>
    <footer-index v-if="!isAdminPage"></footer-index>
    <el-dialog
      v-if="editTagDialogVisible"
      class="global-dialog add-tag-dialog"
      :visible.sync="editTagDialogVisible"
      :lock-scroll="false"
      title="修改模板分类"
      width="640px"
    >
      <div>支持自定义多个标签，点击Enter键完成单个标签输入</div>
      <self-select v-model="editTags.tags" ref="tagSelect">
        <self-option v-if="!isAdminPucTpl" value="" key="-1" @onClick="newTag">
          <div slot="header">新建标签</div>
        </self-option>
        <self-option
          v-for="(item, index) in tagsListFilter"
          :key="index"
          :label="
            isAdminPucTpl ? item.name : typeNameMap[item.name] || item.name
          "
          :value="isAdminPucTpl ? item.id : item.name"
        >
        </self-option>
      </self-select>
      <span slot="footer">
        <el-button @click="editTagDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveEditTag" :loading="saveTagLoading"
          >确认</el-button
        >
      </span>
    </el-dialog>
    <template-manage
      v-model="templateManageVisible"
      :object="selectGroup"
      @onForward="onTemplateManageForward"
      @onOneHide="onOneHide"
      @clearItem="clearItem"
      @onClickSwitchTemplate="onClickSwitchTemplate"
      @onClickUpdateTemplate="onClickUpdateTemplate"
    ></template-manage>
    <attr-dialog
      v-model="tplGroupAttrDialogVisible"
      @onSave="onTemplateUpdate"
      :data="tplGroupAttrData"
    ></attr-dialog>
  </el-container>
</template>

<script>
import templateService from '../../../request/service/template-service'
import selfCaroursel from '../self-carousel'
import util from '@/util.js'
import routerMixin from '@/mixins/router-mixin.js'
import worksService from '../../../request/service/works-service'
import tplGroupUploader from '../../templateGroup/uploader/tpl-group-uploader'
import templateManage from './template-manage-dialog'
import templateDemo from './template-demo'
import footerIndex from '../../layout/footer/footer-index'
import {
  empty_template,
  empty_template_group,
  template_type_multiple,
  template_type_free,
  template_type_single,
  template_type_ppt,
  template_type_mapping
} from '@/const.js'
import draggable from 'vuedraggable'
import attrDialog from '../attr-dialog/attr-dialog'
import { mapActions, mapGetters } from 'vuex'

const typeMapping = {
  '-2': template_type_multiple,
  '-3': template_type_single,
  '-4': template_type_ppt,
  '-5': template_type_free
}
export default {
  components: {
    selfCaroursel,
    templateManage,
    attrDialog,
    tplGroupUploader,
    draggable,
    templateDemo,
    footerIndex
  },
  mixins: [routerMixin],
  props: {
    scrollEl: {
      type: String,
      default: '#app'
    },
    projectId: {
      type: String
    }
  },
  data () {
    return {
      items: [],
      templatePreview: false,
      previewList: [],
      current: 0,
      pptType: template_type_ppt,
      singleType: template_type_single,
      freeType: template_type_free,
      multiType: template_type_multiple,
      param: {
        type: '',
        pageNum: 1,
        pageSize: 30,
        tagNames: [],
        categoryId: '',
        widthHeights: [],
        canCommercial: '',
        free: '',
        hidden: null
      },
      loading: true,
      addTemplateLoading: false,
      nomoreData: false,
      projectAdmins: [],
      sizeList: [],
      state: {
        pickedTagIndex: -1,
        pickedSizeIndex: -1
      },
      editTagDialogVisible: false,
      editTags: {
        type: '',
        tags: [],
        tplGroupId: null
      },
      templateManageVisible: false,
      selectGroup: {},
      tplGroupAttrDialogVisible: false,
      tplGroupAttrData: JSON.parse(JSON.stringify(empty_template_group)),
      isExpanded: false,
      tplMenuVisible: true,
      saveTagLoading: false,
      attrVisible: true,
      typeNameMap: template_type_mapping,
      footerToUp: 1
    }
  },
  computed: {
    ...mapGetters({
      pubCategoryList: 'app/categoryList'
    }),
    animationFooter () {
      if (this.footerToUp === 1) {
        return 'footer-up'
      } else if (this.footerToUp === 2) {
        return 'footer-down'
      }
      return ''
    },
    tagsList () {
      return this.isAdminPucTpl
        ? this.pubCategoryList
        : this.$store.state.app.templateIndexTags
    },
    tagsListFilter () {
      // 过滤掉系统默认值
      return this.isAdminPucTpl
        ? this.pubCategoryList
        : this.$store.state.app.templateTags.filter(item => {
            return !this.typeNameMap[item.name]
          })
    },
    isProjectUser () {
      return this.$store.getters['app/isProjectUser']
    },
    freeTplUploaderVisible () {
      return this.$store.getters['app/freeTplUploaderVisible']
    },
    fixTplUploaderVisible () {
      return this.$store.getters['app/fixTplUploaderVisible']
    },
    isAdminPage () {
      return (
        ['admin-template-public', 'admin-template-pre'].indexOf(
          this.$route.name
        ) > -1
      )
    },
    isTplPage () {
      return this.$route.path.indexOf('/template') > -1
    },
    multiUploader () {
      if (this.isAdminPage) {
        // 公共模板管理页，允许固定和自由模板上传
        return true
      } else {
        // 非管理页，只允许固定或自由模板上传，或者全部禁用
        return this.freeTplUploaderVisible && this.fixTplUploaderVisible
      }
    },
    isAdminPucTpl () {
      return this.$route.name === 'admin-template-public'
    },
    uploaderVisible () {
      return this.isAdminPage
      // if (this.isAdminPage) {
      //   return true
      // } else {
      //   return (
      //     this.$store.getters['app/isAdmin'] && 'template' === this.$route.name
      //   )
      // }
    }
  },
  watch: {
    projectId (val) {
      if (val) {
        this.param = {
          pageNum: 1,
          pageSize: 30,
          tagNames: [],
          categoryId: '',
          widthHeights: []
        }
        this.state = {
          pickedTagIndex: -1,
          pickedSizeIndex: -1
        }
        this.init()
      }
    }
  },
  beforeDestroy () {
    this.eventBus.$off('refreshTplData', this.getData)
    let scrollDom = document.querySelector(this.scrollEl)
    scrollDom && scrollDom.removeEventListener('scroll', this.onScroll)
  },
  mounted () {
    this.init()
    this.initEvent()
  },
  methods: {
    ...mapActions({
      getTplCategoryList: 'app/getTplCategoryList'
    }),
    init () {
      worksService.getProjectAdmin(this.projectId).then(data => {
        this.projectAdmins = data
      })
      this.getSizeList()
      this.getTags()
      this.getData()
      this.getProjectAdminInfo()
      this.eventBus.$on('refreshTplData', this.getData)
    },
    initEvent () {
      document
        .querySelector(this.scrollEl)
        .addEventListener('scroll', this.onScroll)
    },
    isTeamTemplate (type) {
      return type === template_type_single // 单图模板
    },
    isMulti (type) {
      return type === template_type_multiple
    },
    isPPT (type) {
      return type === template_type_ppt
    },
    getTags () {
      if (this.isAdminPucTpl) {
        this.getTplCategoryList(this.$store.state.app.loginUser.publicProject.id)
      } else {
        this.$store.dispatch('app/queryTemplateIndexTagList', this.projectId)
        this.$store.dispatch('app/queryTemplateTagList', this.projectId)
      }
    },
    getProjectAdminInfo () {
      worksService.getProjectAdmin(this.projectId).then(data => {
        this.projectAdmins = data
      })
    },
    getSizeList () {
      // type tagName 不会同时有值
      let sizeParams = {
        canCommercial: this.param.canCommercial || '',
        tagNames: this.param.tagNames || '',
        type: this.param.type || '',
        hidden: this.param.hidden
      }
      templateService.getTemplateSize(this.projectId, sizeParams).then(data => {
        this.sizeList = data
      })
    },
    getData () {
      this.loading = true
      this.param.pageNum = 1
      const params = {
        ...this.param,
        projectId: this.projectId
      }
      if (this.isAdminPucTpl) {
        delete params.tagNames
      } else {
        delete params.categoryId
      }
      this.getTemplateList(
        params
        // Object.assign({}, this.param, { projectId: this.projectId })
      )
        .then(data => {
          let dataList = data.list || []
          dataList.forEach(item => {
            item.visible1 = false
          })
          this.items = dataList
        })
        .finally(() => {
          this.loading = false
        })
      if (this.param.tagNames && this.param.tagNames.length > 0) {
        this.saveUserAction(
          this.ActionType.template.name.key,
          this.ActionType.template.tagSearch.key
        )
      }
      if (this.param.widthHeights && this.param.widthHeights.length > 0) {
        this.saveUserAction(
          this.ActionType.template.name.key,
          this.ActionType.template.sizeSearch.key
        )
      }
    },
    getTemplateList (param) {
      return templateService.getTemplateList(param)
    },
    addTemplate () {
      if (this.nomoreData) {
        return
      }
      this.addTemplateLoading = true
      this.param.pageNum += 1
      this.getTemplateList(
        Object.assign({}, this.param, { projectId: this.projectId })
      )
        .then(data => {
          this.items = this.items.concat(data.list)
          if (data.list && data.list.length) {
            this.nomoreData = false
          } else {
            this.nomoreData = true
            this.param.pageNum -= 1
            setTimeout(() => {
              this.nomoreData = false
            }, 3000)
          }
        })
        .finally(() => {
          this.addTemplateLoading = false
        })
    },
    previewTemplate (item) {
      this.previewList = item.templates
      this.templatePreview = true
      // if(item.type === template_type_multiple){
      //     this.saveUserAction(this.ActionType.templateGroup.name.key, this.ActionType.templateGroup.preview.key);
      // }else{
      this.saveUserAction(
        this.ActionType.template.name.key,
        this.ActionType.template.preview.key,
        item.type,
        item.id
      )
      // }
    },
    goToEditor (data) {
      let item = data.templates[0]
      this.saveUserAction(
        this.ActionType.template.name.key,
        this.ActionType.template.goToEditor.key,
        item.type,
        id
      )
      let id = item.id
      if (item.type == template_type_single && data.templates.length > 1) {
        this.manageTemplate(data)
      } else {
        this.forwardMapping(item.type, id, item.free)
      }
    },
    onTemplateManageForward (type, id, free) {
      this.forwardMapping(type, id, free)
    },
    forwardMapping (type, id, free) {
      if (free) {
        this.goToTplFreeEditor(id)
        return
      }
      let obj = {}
      obj[this.pptType] = () => {
        this.goToTplGroupEditor(id)
      }
      obj[this.multiType] = () => {
        this.goToTplGroupEditor(id)
      }
      obj[this.singleType] = () => {
        this.toUse(id)
      }
      let func = obj[type]
      func && func()
    },
    onClickUse (data) {
      let item = data.templates[0]
      if (item.type !== template_type_single) {
        this.saveUserAction(
          this.ActionType.template.name.key,
          this.ActionType.templateGroup.edit.key,
          item.type,
          item.id
        )
      } else {
        this.saveUserAction(
          this.ActionType.template.name.key,
          this.ActionType.template.edit.key,
          item.type,
          item.id
        )
      }
      this.forwardMapping(data.type, item.id, item.free)
    },
    toUseTemplate (item) {
      this.saveUserAction(
        this.ActionType.template.name.key,
        this.ActionType.template.useTemplate.key,
        item.type,
        item.id
      )
      this.forwardMapping(item.type, item.id, item.free)
    },
    toUse (id) {
      const tplRouter = this.$router.resolve({
        path: '/template/' + id + '/editor',
        param: {
          id: id
        }
      })
      window.open(tplRouter.href, '_blank')
    },
    goToTplGroupEditor (id) {
      const tplGroupRouter = this.$router.resolve({
        path: '/templateGroup/' + id + '/editor'
      })
      window.open(tplGroupRouter.href, '_blank')
    },
    goToTplFreeEditor (id) {
      const tplFreeRouter = this.$router.resolve({
        path: '/tplFree/' + id + '/editor'
      })
      window.open(tplFreeRouter.href, '_blank')
    },
    onScroll (evt) {
      if (this.isTplPage) {
        this.setFooterAnimation()
        if (this.scrollTimeoutVal) {
          window.clearTimeout(this.scrollTimeoutVal)
        }
        let scrollTop = evt.target.scrollTop,
          scrollBottom = evt.target.scrollHeight - evt.target.offsetHeight
        // scrollHeight文档长度，offsetHeight可视区域内长度，scrollTop可视区域上方距离文档上方距离也就是滚动距离
        if (scrollBottom - scrollTop > 5 || scrollTop === 0) {
          return
        }
        this.scrollTimeoutVal = setTimeout(() => {
          this.addTemplate()
        }, 200)
      }
    },
    setFooterAnimation () {
      if (this.footerToUp === 3) {
        return
      }
      this.footerToUp = 2
      setTimeout(() => {
        this.footerToUp = 3
      }, 500)
    },
    getWidth () {
      return util.getWidth()
    },
    getListStyle () {
      let w = util.getWidthNum(),
        tplW = 220
      let margin = w - Math.floor(w / tplW) * tplW
      return `margin-left: ${margin / 2}px;`
    },
    onSwitchPng () {
      this.saveUserAction(
        this.ActionType.template.name.key,
        this.ActionType.template.switch.key
      )
    },
    onUploadSuccess () {
      this.getData()
      this.getTags()
    },
    deleteTemplates (item) {
      let ids = item.templates.map(obj => {
        return obj.id
      })
      templateService
        .deleteTemplates(ids)
        .then(() => {
          let index = this.items.findIndex(el => {
            return item == el
          })
          this.items.splice(index, 1)
          this.$message({
            duration: 1000,
            message: '删除成功',
            type: 'success'
          })
        })
        .catch(e => {
          console.log(e)
        })
    },
    clearItem (item) {
      let index = this.items.findIndex(el => {
        return el.name == item.name
      })
      this.items.splice(index, 1)
    },
    chooseAll () {
      this.param.categoryId = ''
      this.state.pickedSizeIndex = -1
      this.param.widthHeights = []
      this.queryByTag()
      this.getSizeList()
    },
    choseTag (name, index, id) {
      this.param.categoryId = id
      this.state.pickedSizeIndex = -1
      this.param.widthHeights = []
      this.queryByTag(name, index)
      if (
        [this.multiType, this.singleType, this.pptType, this.freeType].includes(
          name
        )
      ) {
        this.getSizeList(name, null)
      } else {
        this.getSizeList(null, name)
      }
    },
    queryByTag (name, index) {
      this.param.pageNum = 1
      this.param.pageSize = 30
      if (name) {
        this.state.pickedTagIndex = index
        this.param.tagNames = [name]
      } else {
        this.state.pickedTagIndex = -1
        this.param.tagNames = []
      }
      // 图文和团队两个标签，用来过滤模板类型，tagNames 需为空
      if (
        [this.multiType, this.singleType, this.pptType, this.freeType].includes(
          name
        )
      ) {
        this.param.type = name
        this.param.tagNames = []
      } else {
        this.param.type = null
      }
      this.getData()
    },
    choseSize (size, index) {
      this.param.pageNum = 1
      this.param.pageSize = 30
      if (size) {
        this.state.pickedSizeIndex = index
        this.param.widthHeights = [size]
      } else {
        this.state.pickedSizeIndex = -1
        this.param.widthHeights = []
      }
      this.getData()
    },
    editTag (item) {
      this.editTagDialogVisible = true
      this.editTags.tplGroupId = item.templates[0].tplGroupId
      if (item.intersectionTagNames) {
        this.editTags.tags = this.isAdminPucTpl
          ? item.categoryIds
          : item.intersectionTagNames
      }
      this.editTags.type = item.type

      // if(item.type === template_type_multiple){
      //     this.saveUserAction(this.ActionType.templateGroup.name.key, this.ActionType.templateGroup.editTag.key);
      // }else{
      this.saveUserAction(
        this.ActionType.template.name.key,
        this.ActionType.template.editTag.key,
        item.type,
        item.id
      )
      // }
    },
    saveEditTag () {
      this.saveTagLoading = true
      let params = {
        tplGroupId: this.editTags.tplGroupId,
        type: this.editTags.type
      }
      if (this.isAdminPucTpl) {
        params.categoryIds = this.editTags.tags
        templateService
          .setTplCategory(this.projectId, params)
          .then(() => {
            this.getData()
            this.getTags()
          })
          .finally(() => {
            this.editTagDialogVisible = false
            this.saveTagLoading = false
          })
      } else {
        params.tagNames = this.editTags.tags
        templateService
          .setTemplateGroupTag(this.projectId, params)
          .then(() => {
            this.getData()
            this.getTags()
          })
          .finally(() => {
            this.editTagDialogVisible = false
            this.saveTagLoading = false
          })
      }
    },
    newTag () {
      this.$refs.tagSelect.togglePopover(false)
    },
    manageTemplate (item) {
      this.templateManageVisible = true
      this.selectGroup = item
    },
    async onClickUpdateTemplate (item) {
      if (item.tags) {
        item.tagNames = item.tags.map(item => {
          return item.name
        })
      }
      templateService.getTemplateById(item.id).then(data => {
        data.tplGroupName = data.isDefaultTplGroup ? '' : data.tplGroupName
        this.tplGroupAttrData = data
        this.tplGroupAttrDialogVisible = true
      })
    },
    onExpandClick () {
      this.isExpanded = !this.isExpanded
    },
    onDelTag (item, index) {
      if (this.state.pickedTagIndex === index) {
        this.choseTag()
      }
      templateService.delTemplateTag(item.id).then(() => {
        let dataList = this.tagsList.filter(obj => {
          return obj.id !== item.id
        })
        this.$store.commit('app/set_template_index_tags', dataList)
        this.$message.success({
          message: '操作成功',
          duration: 1000
        })
      })
    },
    onOneHide (item) {
      this.hideTemplate(this.projectId, [item.id], !item.hidden)
    },
    onHideGroup (groupItem) {
      this.tplMenuVisible = false
      let pid = this.projectId
      let tIdArray = groupItem.templates.map(obj => {
        return obj.id
      })
      groupItem.opMenuVisible = false
      this.hideTemplate(pid, tIdArray, !groupItem.hidden)
      // this.$nextTick(() => {//刷新操作菜单 ，否则文字不会切换
      //     this.tplMenuVisible = true;
      // })
    },
    hideTemplate (pid, tIdArray, showOrHide) {
      templateService.hideTemplate(pid, tIdArray, showOrHide).then(() => {
        this.$message.success({
          message: '操作成功',
          duration: 1000
        })
        document.querySelector(this.scrollEl).scrollTop = 0
        this.getData()
      })
    },
    onDragEnd ({ oldIndex, newIndex }) {
      if (this.items.length === 0) {
        return
      }
      let sortNum = 0
      let lastIndex = this.items.length - 1
      if (newIndex === 0) {
        sortNum = parseInt(+this.items[1].sortNum / 2)
      } else if (newIndex === lastIndex) {
        sortNum = parseInt(+this.items[lastIndex - 1].sortNum / 2)
      } else {
        let startNum = +this.items[newIndex - 1].sortNum
        let endNum = +this.items[newIndex + 1].sortNum
        sortNum = parseInt((startNum + endNum) / 2)
      }
      let item = this.items[newIndex]
      if (newIndex === this.items.length - 1) {
        // 移动到最末尾
        sortNum = +this.items[newIndex - 1].sortNum + 1
      }
      templateService
        .sortTemplateGroup(this.projectId, item.id, sortNum)
        .then(() => {
          item.sortNum = sortNum
          this.getData()
        })
    },
    onClickSwitchTemplate (item) {
      this.$confirm('确定要把当前模板转成自由模板?', '', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          templateService.copyToTemplateFree(item.id).then(id => {
            this.getData()
            this.goToTplFreeEditor(item.id)
          })
        })
        .catch(() => {})
    },
    chooseCopyRight (canCommercial) {
      this.param.canCommercial = canCommercial
      this.getSizeList()
      this.getData()
    },
    chooseFree (isFree) {
      this.param.free = isFree
      this.getSizeList()
      this.getData()
    },
    freeTplBtnVisible (item) {
      let getters = this.$store.getters
      return (
        getters['app/isAdmin'] &&
        getters['app/freeTplVisible'] &&
        !item.templates[0].free
      )
    },
    onTemplateUpdate () {
      this.getTags()
      this.getData()
    },
    isPreTemplate (item) {
      //预置模板不能做属性修改
      let isUserTemplatePage = this.$route.path === '/template'
      return (
        item.projectId ===
          this.$store.state.app.loginUser.preliminaryProject.id &&
        isUserTemplatePage
      )
    },
    chooseTplStatus (trueOrFalse) {
      this.param.hidden = trueOrFalse
      this.getSizeList()
      this.getData()
    }
  }
}
</script>
<style lang="scss">
@import './template-list-index.scss';
</style>
